import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';

import clsx from 'clsx';

import { reducerGoodsStatus } from '../../../redux/reducer/tunder/reducers/reducerGoods';
import { generateStyles } from '../../../utils/generateToastStyles';
import { AppDispatch } from '../../../redux/reducer/store';
import { actionGetProductsOsa } from '../../../redux/action/tunder/actionGoods';

import LimitSelect from '../../custom/limitSelect/limitSelect';
import ToastPopup from '../../custom/toastPopup/toastPopup';
import Pagination from '../../pagination/pagination';
import Loader from '../../custom/loader/loader';

import '../table.scss';
import { IUserOptions } from '../../../types/interfaces';

interface IGood {
	osaName: string;
	sku: {
		id: number;
		name: string
	};
	osaCode: number;
	product_name?: string;
	barcode: number;
};

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableGoods: FC = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { goods, pages, count, offset, status, limit } =
		useSelector((state: any) => state.tunder.goods);
	const { isOpenSidebar, data } = useSelector((state: IUserOptions) => state.user.user);
	const [isPending, setIsPending] = useState<boolean>(false);
	const [currentPage, setCurrentPage] = useState<number>(pages);
	const [startPage, setStartPage] = useState<number>(1);
	const actualLimit =
		JSON.parse(localStorage.getItem('pageLimit') as string) || limit;

	useEffect(() => {
		setIsPending(true);
		dispatch(actionGetProductsOsa(actualLimit, offset)).then(() => {
			setIsPending(false);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	useEffect(() => {
		if (status === 204) {
			toast(
				t => (
					<ToastPopup
						title='Файл успешно загружен!'
						isSuccess={true}
						toast={toast}
						t={t}
					/>
				),
				generateStyles(true)
			);
		} else if (status === 205) {
			toast(
				t => (
					<ToastPopup
						title={`Список SKU Тандер будет отправлен на почту ${data.email}, когда будет сформирован`}
						isSuccess={true}
						toast={toast}
						t={t}
					/>
				),
				generateStyles(true)
			);
		} else if (status === 0) {
			toast(
				t => (
					<ToastPopup
						title='Ошибка загрузки файлов!'
						isSuccess={false}
						toast={toast}
						t={t}
					/>
				),
				generateStyles()
			);
		} else if (status === 400) {
			toast(
				t => (
					<ToastPopup
						title='Ошибка при загрузки'
						isSuccess={false}
						toast={toast}
						t={t}
					/>
				),
				generateStyles()
			);
		}

		setTimeout(() => {
			dispatch(reducerGoodsStatus(null));
		}, 5000);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, status]);
	const handleChange = (newLimit: number, newOffset: number) => {
		setIsPending(true);
		dispatch(actionGetProductsOsa(newLimit, newOffset)).then(() => {
			setIsPending(false);
		});
		localStorage.setItem('pageLimit', JSON.stringify(newLimit));
	};

	const handleChangeLimits = (option: { value: number }) => {
		handleChange(option.value, 0);
		setCurrentPage(1);
		setStartPage(1);
	};

	// const getPorducts = () => {
	// 	setIsPending(true);
	// 	dispatch(actionGetProductsOsa(actualLimit, offset)).then(() => {
	// 		setIsPending(false);
	// 	});
	// };

	return (
		<>
			<div className='loader__wrapper'>
				{isPending && <Loader />}
			</div>
			<div
				className={clsx(
					JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
					isOpenSidebar &&
					'active__table',
					!isOpenSidebar && 'closed__table',
					'table'
				)}
			>
				{(status || status !== null) && <Toaster
					position='top-center'
					toastOptions={{
						duration: 5000,
					}}
				/>}
				<div className='table__wrapper'>
					<table>
						<thead className='tunder__thead'>
							<tr className='tunder__outlets_tr'>
								<th className='signals__id_cell'>
									<span className='filter__title'>ID Товара Mol</span>
								</th>
								<th className='signals_sku_cell'>
									<span className='filter__title'>Название товара Mol</span>
								</th>
								<th className='signals__id_cell'>
									<span className='filter__title'>ID товара Тандер</span>
								</th>
								<th className='signals__id_cell'>
									<span className='filter__title'>Название товара Тандер</span>
								</th>
								<th className='signals__id_cell'>
									<span className='filter__title'>Штрихкод</span>
								</th>
							</tr>
						</thead>
						<tbody>
							{goods &&
								goods.map((goods: IGood) => (
									<tr key={goods.osaCode}>
										<td className='signals__id_cell'>{goods?.sku?.id}</td>
										<td>{goods?.sku?.name}</td>
										<td className='signals__id_cell'>{goods?.osaCode}</td>
										<td className='signals__id_cell'>{goods?.osaName || ''}</td>
										<td className='signals__id_cell'>{goods?.barcode || ''}</td>
									</tr>
								))}
						</tbody>
					</table>
				</div>
				<div className='pagination'>
					<div className='pagination__count'>Всего: {count}</div>
					<div className='pagination__str'>
						<span>Отображать строки</span>
						<LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
					</div>
					<Pagination
						setCurrentPage={setCurrentPage}
						setStartPage={setStartPage}
						handleChange={handleChange}
						count={count}
						currentPage={currentPage}
						startPage={startPage}
						limit={actualLimit}
					/>
				</div>
			</div>
		</>
	);
};

export default TableGoods;
